var React = require('react');

function NoolParemale (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:#0072ce;}")),React.createElement("g",{"id":"Layer_2","key":1},React.createElement("g",{"id":"Layer_1-2"},React.createElement("polygon",{"className":"cls-1","points":"0 9 24.17 9 16.59 1.41 18 0 28 10 28 10 18 20 16.59 18.59 24.17 11 0 11 0 9"})))]);
}

NoolParemale.defaultProps = {"viewBox":"0 0 28 20"};

module.exports = NoolParemale;

NoolParemale.default = NoolParemale;
